import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { rsaPackageActions } from "./index";
import {
    FETCH_RSA_PACKAGE_LIST_PROGRESS,
    FETCH_RSA_PACKAGE_LIST_SUCCESS,
    FETCH_RSA_PACKAGE_LIST_FAILED,
    FETCH_RSA_PACKAGE_PROGRESS,
    FETCH_RSA_PACKAGE_SUCCESS,
    FETCH_RSA_PACKAGE_FAILED,
    CLEAR_RSA_PACKAGE_STATE,
    CLEAR_RSA_PACKAGE,
} from "./rsaPackages.actions";
import { initialRsaPackageState } from "./rsaPackages.states";

export const rsaPackageReducer = (
    state: IStoreState["rsaPackage"] = initialRsaPackageState,
    action: rsaPackageActions
) => {
    switch (action.type) {
        // ==================== RSA PACKAGE LIST REDUCERS ====================

        case FETCH_RSA_PACKAGE_LIST_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.RsaPackage.list.loading = LoadState.InProgress;
                draftState.RsaPackage.list.list = [];
                draftState.RsaPackage.list.totalRecords = 0;
                draftState.RsaPackage.list.error = null;
            });
        }

        case FETCH_RSA_PACKAGE_LIST_SUCCESS: {
            const { list, totalRecords } = action.payload;
            return produce(state, (draftState) => {
                draftState.RsaPackage.list.loading = LoadState.Loaded;
                draftState.RsaPackage.list.list = list;
                draftState.RsaPackage.list.totalRecords = totalRecords;
            });
        }

        case FETCH_RSA_PACKAGE_LIST_FAILED: {
            return produce(state, (draftState) => {
                draftState.RsaPackage.list.loading = LoadState.Failed;
                draftState.RsaPackage.list.list = [];
                draftState.RsaPackage.list.totalRecords = 0;
            });
        }

        // ==================== SINGLE RSA PACKAGE REDUCERS ====================

        case FETCH_RSA_PACKAGE_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.RsaPackage.data.loading = LoadState.InProgress;
                draftState.RsaPackage.data.data = null;
                draftState.RsaPackage.data.error = null;
            });
        }

        case FETCH_RSA_PACKAGE_SUCCESS: {
            const { rsaPackage } = action.payload;
            return produce(state, (draftState) => {
                draftState.RsaPackage.data.loading = LoadState.Loaded;
                draftState.RsaPackage.data.data = rsaPackage;
            });
        }

        case FETCH_RSA_PACKAGE_FAILED: {
            const { errorMessage } = action.payload;
            return produce(state, (draftState) => {
                draftState.RsaPackage.data.loading = LoadState.Failed;
                draftState.RsaPackage.data.error = errorMessage;
            });
        }

        // ==================== CLEAR REDUCERS ====================

        case CLEAR_RSA_PACKAGE: {
            return produce(state, (draftState) => {
                draftState.RsaPackage.data.loading = LoadState.NotLoaded;
                draftState.RsaPackage.data.data = null;
                draftState.RsaPackage.data.error = null;
            });
        }

        case CLEAR_RSA_PACKAGE_STATE: {
            return produce(state, (draftState) => {
                draftState.RsaPackage = initialRsaPackageState.RsaPackage;
            });
        }

        default: {
            return state;
        }
    }
};
